import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Feature } from '@app/core/interfaces/c5/feature';
import { NumberRange } from '@app/core/interfaces/c5/number-range';
import { NumberRangeUpdate } from '@app/core/interfaces/portal/number-range-update';
import { Utils } from '@app/shared/services/utils.service';
import { Features } from '@business/feature/interfaces/features';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NumberRangeRepository {
  constructor(
    private http: HttpClient,
    private utils: Utils
  ) {}

  add(numberRange: NumberRangeUpdate, userId: number): Observable<NumberRange> {
    return this.utils.apiUrl(`/numberRanges`).pipe(
      mergeMap((url) =>
        this.http.post<NumberRange>(url, numberRange, {
          params: {
            userId: String(userId),
          },
        })
      )
    );
  }

  delete(id: number): Observable<void> {
    return this.utils.apiUrl(`/numberRanges/${id}`).pipe(mergeMap((url) => this.http.delete<void>(url)));
  }

  getFeatures(id: number): Observable<Features> {
    return this.utils
      .apiUrl(`/numberRanges/${id}/features`)
      .pipe(mergeMap((url) => this.http.get<Features>(url)));
  }

  update(id: number, numberRange: NumberRange): Observable<NumberRange> {
    return this.utils
      .apiUrl(`/numberRanges/${id}`)
      .pipe(mergeMap((url) => this.http.put<NumberRange>(url, numberRange)));
  }

  updateFeature(id: number, feature: Feature): Observable<Feature> {
    return this.utils
      .apiUrl(`/numberRanges/${id}/features/${feature.id}`)
      .pipe(mergeMap((url) => this.http.put<Feature>(url, feature)));
  }
}
